import Contact from "@/components/waylio/Contact";

export default function ContactPage() {
  return (
    <main className="pt-10 md:pt-12">
      <Contact />
    </main>
  );
}
